// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media only screen and (min-device-width:320px) and (max-device-width:768px){[data-v-7f669b7f] .p-button{white-space:nowrap}}", ""]);
// Exports
module.exports = exports;
